/** Type that is commonly used in the API of components that allow customizing their content. */
export type Content = string | Node | (string | Node)[];

export function isContent (value: unknown): value is Content {
  return isStringOrNode(value) || (Array.isArray(value) && value.every(isStringOrNode));
}

function isStringOrNode (value: unknown): value is string | Node {
  return (typeof value === 'string' || value instanceof Node);
}
